import React, { useState } from 'react';
import "./css/IconButton.css";

export function IconButton({ src, srcWhite, disabled, disabledIcon, onClick }) {
    const [imageSrc, setImageSrc] = useState(src);
    return (
        <div className="subfunction" id="add-playlist"
            style={disabled ? { background: "#FFF", cursor: "no-drop" } : {}}
            onClick={() => { if (!disabled) onClick() }}
            onMouseEnter={() => { if (!disabled) setImageSrc(srcWhite) }}
            onMouseDown={() => { if (!disabled) setImageSrc(srcWhite) }}
            onMouseLeave={() => { if (!disabled) setImageSrc(src) }}
        >
            <img className="component-1" id="add-playlist-icon" src={disabled ? disabledIcon : imageSrc} />
        </div>
    );
}

